var _clipPath, _clipPath2, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTv = function SvgTv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 600"
  }, props), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "tv_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h650v350H0z"
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "tv_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v150h650v150h-50zm0 300v50h300V0h300z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    d: "M0 0h1200v600H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 60,
    d: "m0 0 600 300m0-300L0 300",
    clipPath: "url(#tv_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 40,
    d: "m0 0 600 300m0-300L0 300",
    clipPath: "url(#tv_svg__b)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 100,
    d: "M0 150h650M300 0v350"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c8102e",
    strokeWidth: 60,
    d: "M0 150h650M300 0v350"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#009cde",
    d: "M0 300h600V0h600v600H0z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fedd00",
    d: "m645.34 490.913 29.436 90.597-77.066-55.992h95.26l-77.067 55.993zM817.462 464l-29.436 90.597L758.589 464l77.066 55.992h-95.26zm0-121.984-29.436 90.597-29.437-90.597 77.066 55.992-95.26.001zm126.005 91.152-29.437 90.597-29.436-90.597 77.066 55.992-95.26.001zm0-265.413-29.437 90.597-29.436-90.597 77.066 55.992H866.4zm52.975 172.21 29.436 90.597-77.066-55.992h95.26l-77.067 55.993zm52.923-208.404-29.437 90.597-29.437-90.597 77.067 55.992-95.26.001zm53.471 139.913 29.437 90.597-77.067-55.992h95.26l-77.067 55.993zm0-234.069 29.437 90.597-77.067-55.992h95.26l-77.067 55.993z"
  })));
};
export default SvgTv;